import ProtectedRoute from '@components/ProtectedRoutes'
import { lazy, Suspense } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import adminRoutes from './routes/adminRoutes'
import publicRoutes from './routes/publicRoutes'
import userRoutes from './routes/userRoutes'
import { useEffect } from 'react'
const AdminLayout = lazy(
  () => import('@components/layouts/private/admin/AdminLayout'),
)
const PublicLayout = lazy(
  () => import('@components/layouts/public/PublicLayout'),
)
const UserLayout = lazy(
  () => import('@components/layouts/private/user/UserLayout'),
)
const App = () => {
  const handleContextMenu = (e) => {
    if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      e.preventDefault()
    }
  }
  useEffect(() => {
    document.addEventListener('contextmenu', handleContextMenu)
    document.addEventListener('gesturestart', (e) => e.preventDefault())
    document.addEventListener('gesturechange', (e) => e.preventDefault())
    document.addEventListener('gestureend', (e) => e.preventDefault())

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu)
    }
  }, [])
  return (
    <BrowserRouter>
      <Suspense fallback={<></>}>
        <Routes>
          <Route path="/" element={<PublicLayout />}>
            {publicRoutes?.map((item, i) => <Route {...item} key={i} />)}
          </Route>
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute
                allowedRoles={['admin']}
                Component={AdminLayout}
              />
            }
          >
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            {adminRoutes.map((item, i) => (
              <Route {...item} key={i} />
            ))}
          </Route>
          <Route
            path="/books/*"
            element={
              <ProtectedRoute allowedRoles={['user']} Component={UserLayout} />
            }
          >
            {userRoutes.map((item, i) => (
              <Route {...item} key={i} />
            ))}
            {publicRoutes?.map((item, i) => <Route {...item} key={i} />)}
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default App
